import { render, staticRenderFns } from "./rewardCollectEdit.vue?vue&type=template&id=5f75d474&scoped=true&"
import script from "./rewardCollectEdit.vue?vue&type=script&lang=js&"
export * from "./rewardCollectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f75d474",
  null
  
)

export default component.exports